'use strict';
import * as $j_app$002edata$002e$002dOrganization$002dEmail$0024package$0024$002dOrganization$002dEmail$0024 from "./app.data.-Organization-Email$package$-Organization-Email$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$() {
  this.aCQ = null;
  this.aD7 = null;
  this.aCT = null;
  this.aCU = false;
  this.aCZ = null;
  this.aD0 = false;
  this.aD5 = null;
  this.aD6 = false;
  this.aCR = null;
  this.aCS = false;
  this.aD3 = null;
  this.aD4 = false;
  this.aD1 = null;
  this.aD2 = false;
  this.aCV = null;
  this.aCW = false;
  this.aCX = null;
  this.aCY = false;
  $n_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$ = this;
  this.aCQ = $j_app$002edata$002e$002dOrganization$002dEmail$0024package$0024$002dOrganization$002dEmail$0024.$m_Lapp_data_OrganizationEmail$package$OrganizationEmail$();
  this.aD7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002e$002dOrganization$002dEmail$0024package$0024$002dOrganization$002dEmail$0024.$m_Lapp_data_OrganizationEmail$package$OrganizationEmail$());
}
export { $c_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$ as $c_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$ };
$p = $c_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$;
/** @constructor */
function $h_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$() {
}
export { $h_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$ as $h_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$ };
$h_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$.prototype = $p;
$p.eR = (function() {
  return this.aCQ;
});
$p.eO = (function() {
  return this.aD7;
});
$p.bW = (function() {
  if ((!this.aCU)) {
    this.aCT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aCU = true;
  }
  return this.aCT;
});
$p.b9 = (function() {
  if ((!this.aD0)) {
    this.aCZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aD0 = true;
  }
  return this.aCZ;
});
$p.b3 = (function() {
  if ((!this.aD6)) {
    this.aD5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aD6 = true;
  }
  return this.aD5;
});
$p.aG = (function() {
  if ((!this.aCS)) {
    this.aCR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aCS = true;
  }
  return this.aCR;
});
$p.az = (function() {
  if ((!this.aD4)) {
    this.aD3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aD4 = true;
  }
  return this.aD3;
});
$p.aY = (function() {
  if ((!this.aD2)) {
    this.aD1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aD2 = true;
  }
  return this.aD1;
});
$p.bNc = (function() {
  if ((!this.aCW)) {
    this.aCV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Email";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aCW = true;
  }
  return this.aCV;
});
$p.bND = (function() {
  if ((!this.aCY)) {
    this.aCX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aCY = true;
  }
  return this.aCX;
});
var $d_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$, "app.data.OrganizationEmail$package$OrganizationEmailForm$", ({
  Eh: 1,
  N: 1
}));
export { $d_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$ as $d_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$ };
var $n_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$;
function $m_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$() {
  if ((!$n_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$)) {
    $n_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$ = new $c_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$();
  }
  return $n_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$;
}
export { $m_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$ as $m_Lapp_data_OrganizationEmail$package$OrganizationEmailForm$ };
//# sourceMappingURL=app.data.-Organization-Email$package$-Organization-Email-Form$.js.map
